require('../../modules/es6.reflect.get');
module.exports = require('../../modules/_core').Reflect.get;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/reflect/get.js
// module id = /PRc
// module chunks = 63